;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.bpu.show')
    .controller('BpuShowToolbarController', BpuShowToolbarController)

  BpuShowToolbarController.$inject = [
    // Angular
    '$http', 'urls', '$state',
    // Libs
    '$uibModal',
    // Managers
    'ProductManager',
    // Services
    'SnackService',
    // Const
    // Resolved
    'bpu', 'products'
  ]

  function BpuShowToolbarController (
    // Angular
    $http, urls, $state,
    // Libs
    $uibModal,
    // Managers
    ProductManager,
    // Services
    SnackService,
    // Const
    // Resolved
    bpu, products
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        label: bpu.label,
        bpu: bpu,
        products: products,
        // Public Method
        archiveBpu: archiveBpu,
        modifyBpuProducts: modifyBpuProducts
      })
    }

    function archiveBpu () {
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/bpu/show/controllers/modals/archive/archive-bpu-modal.template.html',
        resolve: {
        },
        controller: 'ArchiveBpuModalController',
        controllerAs: 'ctrl'
      }).result.then(function (archiveProducts) {
        self.bpu.archive(archiveProducts)
          .then(function () {
            SnackService.snack({
              text: 'BPU archivé',
              delay: 3000
            })
          })
      })
    }

    function modifyBpuProducts () {
      let query = ProductManager.query(
        {
          conditions: {
            bpu: self.bpu._id
          },
          archived: 'both'
        })
      ProductManager.post(query)
        .then(function (data) {
          let ids = data.data.map(product => product._id)
          return $uibModal.open({
            size: 'lg',
            templateUrl: '/app/modules/product/show/controllers/modals/modify/modify-price-modal.template.html',
            controller: 'ModifyPriceModalController',
            controllerAs: 'ctrl'
          }).result.then((value) => {
            const url = urls.api + '/kilo/products/bulkProductModification'
            return $http.put(url, { type: 'price', ids: ids, value: value }).then(() => {
              SnackService.snack({
                text: 'Prix des produits modifiés !',
                delay: 3000
              })
              $state.reload()
            })
          })
        })
    }
  }
})(window.angular, window._)
